export interface ITabs {
  name?: string;
  credits_tab: boolean;
  own_capitals_tab: boolean;
  leasings_tab: boolean;
  capexs_tab: boolean;
  working_capital_tab: boolean;
  venture_tab: boolean;
}
